<template>
  <div class="headlines">
      <img src="../assets/images/headlines.png" alt="" class="headlines-icon">
      <div class="text-box" v-for="(item, index) in list.contents" :key="index">
        <template v-if="index == 0">
          <div class="title"><a v-if="item.subject" :href="'#'+'/article'+list.url+'/'+item.id">{{ item.subject }}</a></div>
          <div class="desc" v-html="item.description"></div>
        </template>
      <div style="clear: both;"></div>
    </div>
  </div>
</template>
<script>
export default ({
  name: "Headlines",
  props: {
    list: {},
  }
})
</script>

<style scoped>
.headlines {
  width: 775px;
  height: 60px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #E3E3E3;
  padding: 10px;
}
.headlines .headlines-icon {
  width: 60px;
  height: 60px;
  float: left;
}
.headlines .text-box {
  width: 670px;
  float: left;
  margin-left: 10px;
}
.headlines .text-box .title {
  font-size: 16px;
  font-weight: bold;
  color: #ba0303;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.headlines .text-box .title a{
  color: #ba0303;
}
.headlines .text-box .desc {
  width: 700px;
  font-size: 15px;
  color: #5a5e66;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  line-height: 2rem;
}
</style>